/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionWithCountsSchema } from '../collection-schema';

export const triageListItemSchema = collectionWithCountsSchema.extend({
  pendingCount: z.number(),
});

export type ITriageListItem = z.infer<typeof triageListItemSchema>;

export const listTriageCollectionsResponseDataSchema = z.array(triageListItemSchema);

export type IListTriageCollectionsResponseData = z.infer<
  typeof listTriageCollectionsResponseDataSchema
>;

export const listTriageCollectionsResponseSchema = createApiResponseSchema(
  listTriageCollectionsResponseDataSchema,
) as z.ZodSchema<IAPI<IListTriageCollectionsResponseData>>;

export type IListTriageCollectionsResponse = IAPI<IListTriageCollectionsResponseData>;
